/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';
import type { InternalApiBaseAlertStatusListConf } from './InternalApiBaseAlertStatusListConf';
import {
    InternalApiBaseAlertStatusListConfFromJSON,
    InternalApiBaseAlertStatusListConfFromJSONTyped,
    InternalApiBaseAlertStatusListConfToJSON,
    InternalApiBaseAlertStatusListConfToJSONTyped,
} from './InternalApiBaseAlertStatusListConf';

/**
 * 
 * @export
 * @interface InternalApiBaseAlertStatusConf
 */
export interface InternalApiBaseAlertStatusConf {
    /**
     * 
     * @type {Array<InternalApiEntityType>}
     * @memberof InternalApiBaseAlertStatusConf
     */
    entityTypes?: Array<InternalApiEntityType>;
    /**
     * 
     * @type {InternalApiBaseAlertStatusListConf}
     * @memberof InternalApiBaseAlertStatusConf
     */
    screeningLists?: InternalApiBaseAlertStatusListConf;
    /**
     * 
     * @type {InternalApiBaseAlertStatusListConf}
     * @memberof InternalApiBaseAlertStatusConf
     */
    customLists?: InternalApiBaseAlertStatusListConf;
    /**
     * 
     * @type {InternalApiBaseAlertStatusListConf}
     * @memberof InternalApiBaseAlertStatusConf
     */
    monitoring?: InternalApiBaseAlertStatusListConf;
    /**
     * 
     * @type {InternalApiBaseAlertStatusListConf}
     * @memberof InternalApiBaseAlertStatusConf
     */
    bridge?: InternalApiBaseAlertStatusListConf;
}

/**
 * Check if a given object implements the InternalApiBaseAlertStatusConf interface.
 */
export function instanceOfInternalApiBaseAlertStatusConf(value: object): value is InternalApiBaseAlertStatusConf {
    return true;
}

export function InternalApiBaseAlertStatusConfFromJSON(json: any): InternalApiBaseAlertStatusConf {
    return InternalApiBaseAlertStatusConfFromJSONTyped(json, false);
}

export function InternalApiBaseAlertStatusConfFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiBaseAlertStatusConf {
    if (json == null) {
        return json;
    }
    return {
        
        'entityTypes': json['entityTypes'] == null ? undefined : ((json['entityTypes'] as Array<any>).map(InternalApiEntityTypeFromJSON)),
        'screeningLists': json['screeningLists'] == null ? undefined : InternalApiBaseAlertStatusListConfFromJSON(json['screeningLists']),
        'customLists': json['customLists'] == null ? undefined : InternalApiBaseAlertStatusListConfFromJSON(json['customLists']),
        'monitoring': json['monitoring'] == null ? undefined : InternalApiBaseAlertStatusListConfFromJSON(json['monitoring']),
        'bridge': json['bridge'] == null ? undefined : InternalApiBaseAlertStatusListConfFromJSON(json['bridge']),
    };
}

export function InternalApiBaseAlertStatusConfToJSON(json: any): InternalApiBaseAlertStatusConf {
    return InternalApiBaseAlertStatusConfToJSONTyped(json, false);
}

export function InternalApiBaseAlertStatusConfToJSONTyped(value?: InternalApiBaseAlertStatusConf | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityTypes': value['entityTypes'] == null ? undefined : ((value['entityTypes'] as Array<any>).map(InternalApiEntityTypeToJSON)),
        'screeningLists': InternalApiBaseAlertStatusListConfToJSON(value['screeningLists']),
        'customLists': InternalApiBaseAlertStatusListConfToJSON(value['customLists']),
        'monitoring': InternalApiBaseAlertStatusListConfToJSON(value['monitoring']),
        'bridge': InternalApiBaseAlertStatusListConfToJSON(value['bridge']),
    };
}

